export default __webpack_public_path__ + "static/media/detail_mobile_5_2.f8ecae7b.png";